import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/datamart-general-types/datamart/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
